<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-title"><a id="page_ix"><strong>CONTENTS</strong></a></h1><a id="page_ix">
</a><p class="toc-fm"><a id="page_ix"></a><span href="#/006_Author_Preface#fm-1" title="Link target outside of Sample">Author’s Preface</span></p>
<p class="toc-fm"><a href="#/008_Abbreviations#fm-2">Principal Abbreviations</a></p>
<p class="toc-part"><a href="#/009_Part01a#pt-1">INTRODUCTION</a></p>
<p class="toc-sec1"><a href="#/009_Part01a#sec2-1">I. Jeremiah among the Prophets</a></p>
<p class="toc-sec2"><a href="#/009_Part01a#sec2-2">II. Jeremiah in His Historical Setting</a></p>
<p class="toc-sec3"><a href="#/009_Part01a#sec2-3">III. The Book of Jeremiah</a></p>
<p class="toc-sec4"><a href="#/009_Part01a#sec2-4">IV. Some Important Issues for Exegesis</a></p>
<p class="toc-sec5"><a href="#/009_Part01a#sec2-5">V. The Life of Jeremiah</a></p>
<p class="toc-sec6"><span href="#/009_Part01b#sec2-6" title="Link target outside of Sample">VI. The Message of Jeremiah</span></p>
<p class="toc-sec7"><span href="#/009_Part01b#sec2-7" title="Link target outside of Sample">VII. The Text</span></p>
<p class="toc-sec8"><span href="#/009_Part01b#sec2-8" title="Link target outside of Sample">VIII. Poetic Forms</span></p>
<p class="toc-sec9"><span href="#/009_Part01b#sec2-9" title="Link target outside of Sample">IX. Analysis of Contents</span></p>
<p class="toc-sec"><span href="#/009_Part01b#sec2-10" title="Link target outside of Sample">X. Select Bibliography</span></p>
<p class="toc-part"><span href="#/010_Part02#pt-2" title="Link target outside of Sample">TEXT AND COMMENTARY</span></p>
<p class="toc-chap"><span href="#/011_Chapter00#ch-0" title="Link target outside of Sample">Superscription (1:1–3)</span></p>
<p class="toc-chap1"><span href="#/012_Chapter01#ch-1" title="Link target outside of Sample">I. The Call of Jeremiah and the Two Visions (1:4–19)</span></p>
<p class="toc-chap2"><span href="#/013_Chapter02a#ch-2" title="Link target outside of Sample">II. The Divine Judgment on Judah and Jerusalem (2:1–25:38)</span></p>
<p class="toc-chap3"><span href="#/014_Chapter03#ch-3" title="Link target outside of Sample">III. Jeremiah’s Controversy with False Prophets (26:1–29:32)</span></p>
<p class="toc-chap4"><span href="#/015_Chapter04#ch-4" title="Link target outside of Sample">IV. The Book of Consolation (30:1–33:26)</span></p>
<p class="toc-chap5"><span href="#/016_Chapter05#ch-5" title="Link target outside of Sample">V. Incidents from the Days of Jehoiakim and Zedekiah (34:1–39:18)</span></p>
<p class="toc-chap6"><span href="#/017_Chapter06#ch-6" title="Link target outside of Sample">VI. Jeremiah’s Experiences after the Fall of Jerusalem (40:1–45:5)</span></p>
<p class="toc-chap7"><span href="#/018_Chapter07#ch-7" title="Link target outside of Sample">VII. Oracles against the Nations (46:1–51:64)</span></p>
<p class="toc-chap8"><span href="#/019_Chapter08#ch-8" title="Link target outside of Sample">VIII. Appendix: The Fall of Jerusalem (52:1–34)</span></p>
<p class="toc-bm"><span href="#/020_Map#bm-1" title="Link target outside of Sample">MAPS</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 007_Contents.vue?22b38249